var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGreyDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(90 8 8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A9A7A4",
    fillRule: "nonzero",
    points: "6.62919213 13.5 5.56832985 12.4509251 9.25537882 8.76378401 0 8.76378401 0 7.23621599 9.25537882 7.23621599 5.56832985 3.55856007 6.62919213 2.5 12.1291921 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreyDown);
export default __webpack_public_path__ + "static/media/Arrow-grey-down.04bab2d7b6b250aef5a2906b87731fbe.svg";
export { ForwardRef as ReactComponent };